// Module
var code = "<p>You may qualify for an interest rate reduction while actively making payments on Direct Debit.</p> ";
// Exports
export default code;